require('./utmzCookie.js')

// Send referrer to requesting iframes
window.addEventListener('message', function(event) {
    if(event.data.action == 'reqReferrer') {
        msg = {
            action: 'sendReferrer',
            referrer: document.referrer,
            gaReferral: window.gaReferral
        }
        event.source.postMessage(msg, '*')
    }
});


// WEBPACK FOOTER //
// ./src/scripts/sendReferrer.js